module.exports = __webpack_public_path__ + "static/media/location.11abdde0.png";